import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SoundCue } from '../audio/sound-cue';
import { AudioService } from './audio.service';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private snackBar = inject(MatSnackBar);
  private audio = inject(AudioService);

  success(message: string, duration = 3000): void {
    this.open(message, duration, 'snk-toast-success');
  }

  error(message: string, duration = 5000): void {
    this.audio.play(SoundCue.UI_ERROR);
    this.open(message, duration, 'snk-toast-error');
  }

  info(message: string, duration = 3000): void {
    this.open(message, duration, 'snk-toast-info');
  }

  warning(message: string, duration = 4000): void {
    this.open(message, duration, 'snk-toast-warning');
  }

  private open(message: string, duration: number, panelClass: string): void {
    // Top-right, nudged below the header (see .snk-toast-* margin in styles.scss)
    // so toasts never cover the centred room block.
    this.snackBar.open(message, 'Close', {
      duration,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: [panelClass],
    });
  }
}
